import { render, staticRenderFns } from "./ShipIcon.vue?vue&type=template&id=52dc96e4&scoped=true"
import script from "./ShipIcon.vue?vue&type=script&lang=js"
export * from "./ShipIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dc96e4",
  null
  
)

export default component.exports